import Component from '@glimmer/component'
import { service } from '@ember/service'
import type LoginCardsRoute from 'teacher-ui-client/login-cards/route'
import type LoginCardsController from 'teacher-ui-client/login-cards/controller'
import { FidgetLoadingIndicatorComponent } from '@blakeelearning/fidget/components/fidget/loading-indicator'
import { LoginCardsPage } from 'teacher-ui-client/components/page/login-cards'
import onImagesLoaded from 'teacher-ui-client/modifiers/on-images-loaded'
import RouteTemplate from 'ember-route-template'
import type SessionService from 'teacher-ui-client/services/session'

interface Signature {
  Args: {
    model: ModelFor<LoginCardsRoute>
    controller: LoginCardsController
  }
}
export class LoginCardsRoutePage extends Component<Signature> {
  @service session!: SessionService

  <template>
    {{#if @model.studentsLoader.isRunning}}
      <FidgetLoadingIndicatorComponent @show={{true}} @centered={{true}} />
    {{else if @model.subscriptionType}}
      <LoginCardsPage
        class="invisible print:visible"
        @subscriptionType={{@model.subscriptionType}}
        @students={{@model.studentsLoader.value}}
        @teacherName={{this.session.currentTeacher.fullName}}
        @schoolName={{this.session.currentSchool.name}}
        {{onImagesLoaded @controller.doPrint}}
      />
    {{/if}}
  </template>
}

export default RouteTemplate(LoginCardsRoutePage)
